import useSlider from "@hooks/useSlider";
import React from "react";

interface ClientTestimonialMasonaryData {
    imageUrl: string;
    description: string;
    author: string;
    position?: string;
}

const ArabicTestimonialSection: React.FC = () => {
    const { loaded, refCallback, currentSlide, slider } = useSlider();

    const clientMasonaryData: ClientTestimonialMasonaryData[] = [
        {
            imageUrl: "https://assets.gallabox.com/gb-home/common-client-logos-without-border/pickyourtrail.svg",
            description: "Best WhatsApp Automation Solution. The bot flow and tech integrations are world class. It is super simple to customize and build bot solutions",
            author: "Natarajan R",
            position: "Senior Product Manager",
        },
        {
            imageUrl: "https://assets.gallabox.com/gb-home/common-client-logos-without-border/ag.svg",
            description:
                "Awesome support team! Gallabox's Customer Success team is very responsive and ready to help if we have any questions. This is a huge differentiator for us since we deal with hundreds of live customer conversations and timely support is needed.",
            author: "Prakash G",
            position: "",
        },
        {
            imageUrl: "https://assets.gallabox.com/gb-home/common_client_logos/gainwell.svg",
            description: "Brilliant Software | Affordable Pricing | Very Helpful Team | Great Experience",
            author: "Maanav S",
            position: "",
        },
        {
            imageUrl: "https://assets.gallabox.com/gb-home/common_client_logos/rainbow_top_store.svg",
            description: "Works like a miracle for sites built on WooCommerce. The chatbot has become like a STAR team member - handles sales, as well as customer support.",
            author: "Praveen M",
            position: "VP of Sales",
        },
        {
            imageUrl: "https://assets.gallabox.com/gb-home/common_client_logos/sattvic_store.svg",
            description:
                "Must have tool for your e-commerce business, not only helps nurture your potential clients but also, helps reduce RTO by sending instant updates to customers.. so far 101% satisfied by tool",
            author: "Kabir",
            position: "",
        },
    ];

    return (
        <section className="py-10 new-testimonial">
            <div className="w-full md:w-4/5 mx-auto relative">
                <div className="w-full md:w-4/5 card-with-details py-1 md:py-2 md:pl-11 blue-testimonial-card">
                    <div className="max-w-xl text-right pr-8 lg:pt-20">
                        <h2 className=" text-white font-bold text-6xl w-full  my-12">ابدأ تجربتك المجانية لمدة 7 أيام الآن</h2>
                        <div className={"flex justify-center items-center md:hidden"}>
                            <a className="jsx-1957620388 btn hover:no-underline" href="https://app.gallabox.com/signup">
                                ابدأ التجربة المجانية
                            </a>
                        </div>
                        <div className={"flex items-center hidden md:block "}>
                            <a className="jsx-1957620388 btn hover:no-underline" href="https://app.gallabox.com/signup">
                                ابدأ التجربة المجانية
                            </a>
                        </div>
                    </div>
                </div>
                <div className="testimoinal-card  app-slider md:p-7">
                    <div ref={refCallback} className="keen-slider" style={{ height: "100%" }}>
                        {clientMasonaryData.map((each, index) => (
                            <div className="keen-slider__slide slider-card" key={each.author}>
                                <div className="flex flex-col h-full justify-between ">
                                    <div className="" style={{ display: "grid", gridTemplateRows: "52px 130px" }}>
                                        <div className={`${index === 1 ? "w-16" : "w-36"} flex`}>
                                            <img src={each.imageUrl} alt="Client logo" />
                                        </div>
                                        <p className="content ">{each.description}</p>
                                    </div>
                                    <div className="mb-3">
                                        <p className="name ">{each.author}</p>
                                        <p className="role" style={{ height: "18px" }}>
                                            {each.position}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    {loaded && slider.current && (
                        <div className="dots w-fit absolute bottom-2 right-5">
                            {[...Array(slider.current.track.details.slides.length).keys()].map((idx) => {
                                return (
                                    <button
                                        key={idx}
                                        onClick={() => {
                                            slider.current?.moveToIdx(idx);
                                        }}
                                        className={"dot" + (currentSlide === idx ? " active" : "")}
                                    ></button>
                                );
                            })}
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default ArabicTestimonialSection;
